var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAthlete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lp7sj0rgla)",
    fill: "#FDB525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.203 10.938A5.469 5.469 0 1 0 8.203 0a5.469 5.469 0 0 0 0 10.938zm0-9.115a3.645 3.645 0 1 1 0 7.291 3.645 3.645 0 0 1 0-7.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.203 10.886A8.213 8.213 0 0 0 0 19.089a.911.911 0 0 0 1.823 0 6.38 6.38 0 1 1 12.76 0 .912.912 0 1 0 1.824 0 8.213 8.213 0 0 0-8.204-8.203z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lp7sj0rgla"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16.406v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthlete);
export default __webpack_public_path__ + "static/media/Athlete.22d9297660a9f44adec6835943edceb0.svg";
export { ForwardRef as ReactComponent };